import { BASE_URL } from '../components/AppConfig';

const getAuthToken = () => {
  const sessionToken = sessionStorage.getItem('sessionToken');
  return sessionToken ? `Bearer ${sessionToken}` : '';
};

/**
 * GET /admin/arcade/fanwars-lineup?match_id=
 * Optional refresh=1 re-runs lineup sync from DB (squads + performance) for both teams.
 * Response data includes both team configs, teama_name/teamb_name, player_display_by_id,
 * and may include on_demand_sync_attempted, sync_error, sync_skipped.
 */
export const getFanwarsLineup = async (matchId, options = {}) => {
  const token = getAuthToken();
  if (!token) {
    return { statusCode: '50000', message: 'Not authenticated' };
  }
  const params = new URLSearchParams();
  params.set('match_id', String(matchId));
  if (options.refresh) {
    params.set('refresh', '1');
  }
  try {
    const res = await fetch(`${BASE_URL}/admin/arcade/fanwars-lineup?${params.toString()}`, {
      method: 'GET',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
    });
    const data = await res.json().catch(() => ({}));
    return data;
  } catch {
    return { statusCode: '50000', message: 'Failed to load FanWars lineup' };
  }
};

/**
 * PATCH /admin/arcade/fanwars-lineup
 * Partial body: manual_system_player_ids and/or manual_user_pick_order; use null to clear.
 * Success body includes data.config (updated row, including manual snapshots) and
 * data.player_display_by_id for ids on that row.
 */
export const patchFanwarsLineup = async (payload) => {
  const token = getAuthToken();
  if (!token) {
    return { statusCode: '50000', message: 'Not authenticated' };
  }
  try {
    const res = await fetch(`${BASE_URL}/admin/arcade/fanwars-lineup`, {
      method: 'PATCH',
      credentials: 'include',
      headers: {
        'Content-Type': 'application/json',
        Authorization: token,
      },
      body: JSON.stringify(payload),
    });
    const data = await res.json().catch(() => ({}));
    return data;
  } catch {
    return { statusCode: '50000', message: 'Failed to update FanWars lineup' };
  }
};
